import React from "react";
import { Phone } from "lucide-react";

const WHATSAPP_HREF = "https://api.whatsapp.com/send/?phone=966569691027";
// Same verified number already used for WhatsApp across the site — there is
// no separate published phone line, so "Call" dials this number rather than
// inventing a second, unverified contact.
const CALL_HREF = "tel:+966569691027";
const HIDDEN = true;

// Mobile-only sticky CTA bar for individual Service Details pages. Fixed to
// the viewport bottom with safe-area support so it clears the home-indicator
// on notched iPhones instead of sitting under it. Two actions: a direct call,
// and the primary "start your project" action (WhatsApp). A dedicated
// WhatsApp icon button used to sit here too, but it opened the exact same
// chat as the primary button right next to it — pure duplication — so it
// was removed rather than kept as a redundant third tap target.
const ServiceStickyCTA = ({
    href = WHATSAPP_HREF,
    text = "ابدأ مشروعك",
}) => {
    // Hidden sitewide on every service page by request (2026-10-11). The
    // markup below is kept so the bar can be restored by deleting this line.
    if (HIDDEN) return null;

    return (
        <div
            className="service-sticky-cta md:hidden fixed inset-x-4 z-[9999] transition-transform duration-300 ease-out"
            style={{ bottom: "calc(16px + env(safe-area-inset-bottom))" }}
            dir="rtl"
        >
            <div className="flex items-center gap-2.5 rounded-2xl bg-white/90 backdrop-blur-lg border border-gray-100 shadow-[0_10px_30px_-6px_rgba(15,23,42,0.25)] p-2">
                <a
                    href={CALL_HREF}
                    aria-label="اتصل بنا"
                    className="flex items-center justify-center w-12 h-12 shrink-0 rounded-xl bg-slate-50 border border-gray-200 text-slate-600 active:scale-[0.96] transition-transform"
                >
                    <Phone className="w-5 h-5" />
                </a>
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex items-center justify-center h-12 rounded-xl bg-blue-600 text-white font-black text-sm shadow-[0_10px_24px_-6px_rgba(37,99,235,0.5)] active:scale-[0.98] transition-transform"
                >
                    {text}
                </a>
            </div>
        </div>
    );
};

export default ServiceStickyCTA;
